import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [{
    path: '/',
    name: 'Home',
    component: () => import( /* webpackChunkName: 'Home' */ '@/views/Home.vue'),
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/validationCycles',
    component: () => import( /* webpackChunkName: 'ValidationCycleHome' */ '@/views/ValidationCycles/Home.vue'),
    children: [{
        path: '',
        component: () => import( /* webpackChunkName: 'ValidationCycleList' */ '@/views/ValidationCycles/List.vue'),
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: 'edit/:id',
        name: 'ValidationCycleDetails',
        component: () => import( /* webpackChunkName: 'ValidationCycleDetails' */ '@/views/ValidationCycles/Details.vue'),
        meta: {
          requiresAuthentication: true
        }
      }
    ]
  },
  {
    path: '/ccds',
    name: 'Upload CCD',
    component: () => import( /* webpackChunkName: 'UploadCCD' */ '@/views/Case/UploadCCD.vue'),
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/rps',
    component: () => import( /* webpackChunkName: 'RP' */ '@/views/RPs/RP.vue'),
    children: [{
        path: '',
        component: () => import( /* webpackChunkName: 'RPList' */ '@/views/RPs/List.vue'),
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: '/rp/edit/:id',
        component: () => import( /* webpackChunkName: 'RPDetails' */ '@/views/RPs/Details.vue'),
        name: 'RP Profile',
        meta: {
          requiresAuthentication: true
        }
      }
    ]
  },
  {
    path: '/case/list',
    component: () => import( /* webpackChunkName: 'CaseList' */ '@/views/Case/List.vue'),
    name: 'Case List',
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/case/review/:id',
    component: () => import( /* webpackChunkName: 'CaseReview' */ '@/views/Case/Review.vue'),
    name: 'Review Case',
    meta: {
      requiresAuthentication: true
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router